// Generated by scripts/update-seeq-icons.js from src/svg/seeq/dash-dot.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcDashDot = {
  prefix: 'fak',
  iconName: 'dash-dot' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f908',
    'M102.4 465.9h92.2v46.1h-92.2v-46.1zM102.4 512h92.2v46.1h-92.2v-46.1zM425 465.9h414.7v46.1h-414.7v-46.1zM425 512h414.7v46.1h-414.7v-46.1z',
  ],
} satisfies IconDefinition;
